import React, { Fragment } from "react";
import { Polyline, Marker } from "react-leaflet";
import { airspaceType } from "../../constants/airspaceData";
import { getRouteWayPointIcon } from "../../utils/routeWayPointIcon";
import RouteInfoPopup from "./RouteInfoPopup";

export default function RenderWayPointsRouteAirspace({
  routeData,
  handleViewMore,
}) {
  const handlePolygonOver = (e) => {
    e.target.openPopup();
  };

  const handlePolygonClick = (info, subRouteData) => {
    handleViewMore(info, airspaceType.wayPointRoutes, subRouteData);
  };

  return (
    <Fragment>
      {routeData.map((subRouteData, i) => {
        const arrLength = subRouteData?.length || 0;
        const lastRowIndex = arrLength === 0 ? 0 : arrLength - 1;
        const lastRow = subRouteData[lastRowIndex];

        return (
          <Fragment key={i}>
            {subRouteData.map((rnav, i) => {
              const path = [
                rnav.DD_startpoint_coordinates,
                rnav.DD_endpoint_coordinates,
              ];

              return (
                <Polyline
                  key={i}
                  pane="shadowPane"
                  positions={path}
                  pathOptions={{ color: "#ff0000", weight: 2 }}
                  eventHandlers={{
                    mouseover: (e) => handlePolygonOver(e),
                    click: () => handlePolygonClick(rnav, subRouteData),
                  }}
                >
                  <RouteInfoPopup info={rnav} type="both" />
                </Polyline>
              );
            })}
            {subRouteData.map((rnav, i) => {
              return (
                <Marker
                  key={i}
                  pane="markerPane"
                  icon={getRouteWayPointIcon(rnav.startpoint_reportingATC)}
                  position={rnav.DD_startpoint_coordinates}
                  eventHandlers={{
                    mouseover: (e) => handlePolygonOver(e),
                    click: () => handlePolygonClick(rnav, subRouteData),
                  }}
                >
                  <RouteInfoPopup info={rnav} type="start" />
                </Marker>
              );
            })}
            {Boolean(lastRow) && (
              <Marker
                pane="markerPane"
                icon={getRouteWayPointIcon(lastRow.endpoint_reportingATC)}
                position={lastRow.DD_endpoint_coordinates}
                eventHandlers={{
                  mouseover: (e) => handlePolygonOver(e),
                  click: () => handlePolygonClick(lastRow, subRouteData),
                }}
              >
                <RouteInfoPopup info={lastRow} type="end" />
              </Marker>
            )}
          </Fragment>
        );
      })}
    </Fragment>
  );
}
